import packageJson from '../../../package.json';

const serverName = packageJson.serverName;

export const serverDomain =
    (serverName === "production-co") ?
        "production.hinava.co" :
        (serverName + ".hin4v4.ir");